const Logo = ({ light = false }) => {
  return (
    <div className="flex items-center gap-2" data-testid="logo">
      {/* Logo Icon */}
      <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${light ? 'bg-white' : 'bg-[#002FA7]'}`}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={light ? 'text-[#002FA7]' : 'text-white'}
        >
          {/* Refrigerator/Appliance icon */}
          <rect x="4" y="2" width="16" height="20" rx="2" stroke="currentColor" strokeWidth="2" fill="none" />
          <line x1="4" y1="10" x2="20" y2="10" stroke="currentColor" strokeWidth="2" />
          <circle cx="17" cy="6" r="1" fill="currentColor" />
          <circle cx="17" cy="15" r="1" fill="currentColor" />
          <path d="M8 14h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      </div>
      
      {/* Logo Text */}
      <div className="flex flex-col">
        <span className={`font-bold text-lg leading-tight tracking-tight ${light ? 'text-white' : 'text-[#002FA7]'}`}>
          Beyaz Eşya
        </span>
        <span className={`text-sm font-medium leading-tight ${light ? 'text-slate-300' : 'text-slate-600'}`}>
          Al Sat
        </span>
      </div>
    </div>
  );
};

export default Logo;
